import { all, call, put, select, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import {
  licenseAccepted,
  licenseRejected,
  requestLicense,
} from '../../actions/userAccount/user/fetchLicense'
import { fetchLicense, ILicense } from '../../models/License'
import {
  AuthorizationActions,
  UserAccountActions,
} from '../../reducers/userAccount/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import fetchSubs from '../../models/License/fetchSubs'
import cancelSub from '../../models/License/cancelSub'
import { getUser } from '../../reducers/userAccount/selectors/userAccount'

function* getLicense(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.LoadLicenses)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchLicense)),
    ])

    const user = yield select(getUser)
    let subs = undefined
    if(action.requestSubs) {
      try {
        subs = yield * getSubs()
      } catch (e) {
        console.error(e)
      }

    }
    const license: ILicense[] = yield call(service, user, subs)
    if (license.length < 1) {
      throw new Error(`Couldn't get user license data`)
    }

    yield put(licenseAccepted(license))
  } catch (e) {
    yield put(licenseRejected(e.message))
  }
}

export function* getSubs() {
  try {
    const actionNames = fetchActionsName(ActionNames.LoadSubs)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, fetchSubs)),
    ])

    const subs= yield call(service)
    return subs
  } catch (e) {
    yield put(licenseRejected(e.message))
  }
}

function* userIsAuthorized() {
  yield put(requestLicense())
}

function* cancelSubs(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.CancelSub)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, cancelSub)),
    ])

    yield call(service, action.id)
    yield put({type: UserAccountActions.SubCancelled, id: action.id})
  } catch (e) {
    console.error(e)
  }
}


export default function*() {
  yield takeLatest(AuthorizationActions.AuthorizationGranted, userIsAuthorized)
  yield takeLatest(UserAccountActions.RequestLicenseData, getLicense)
  yield takeLatest(UserAccountActions.RequestSubs, getSubs)
  yield takeLatest(UserAccountActions.RequestCancelSub, cancelSubs)
}
